<template>
  <div>
    <div>
      <img v-if="user && user.avatar" class="avaimg" :src="user.avatar.image.path" alt="">
      <img v-else class="avaimg" src="themes/genius/assets/img/ava2.png" alt="">
    </div>
    <!--<span v-if="user && user.role.code === 'student'" class="uk-badge" :uk-tooltip="string">{{ user.scores ? user.scores : 0 }}</span>-->
  </div>
</template>

<script>
export default {
  name: "headscores",
  data() {
    return {}
  },
  props: {
    items: ''
  },
  computed: {
    string() {
      let user = this.user;
      let scores = 'Баллов ' + (user.scores ? user.scores : 0);
      let status = (_.isEmpty(user.status) ? '' : '. Статус ' + user.status.title);
      return scores + status;
    },
    user() {
      return this.$store.state.user;
    }
  },
  methods: {}
}
</script>